export const workerActionInitialize = "initialize";
export const workerActionStartSinglePanelTypeGeneration = "start-single-panel-type-generation";
export const workerActionStartSingleCornerTypeGeneration = "start-single-corner-type-generation";
export const workerActionStartMissingModelGenerations = "start-missing-model-generations";
export const workerActionTrackUnprocessedTypes = "track-unprocessed-types";
export const workerActionAbortGenerationCheck = "abort-model-generation-check";

export const workerResultSinglePanelTypeGenerationStarted = "single-panel-type-generation-started";
export const workerResultSingleCornerTypeGenerationStarted = "single-corner-type-generation-started";
export const workerResultMissingModelGenerationsStarted = "missing-model-generations-started";
export const workerResultGenerationCompleted = "generation-completed";
export const workerResultOperationFailed = "operation-failed";
